import { FormValues } from '../../duck';
import { SelectDistrict } from '../select-district';
import { SelectState } from '../select-state';
import { Button, Flex, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { useQueryParams } from '@lon/mathnation-suit/hooks';
import {
  SsoTypeEnum,
  useGetPublicDistrictQuery,
  useGetPublicDistrictsQuery,
} from '@lon/mathnation-suit/requests';

const autoSso = [
  SsoTypeEnum.Oauth2Clever,
  SsoTypeEnum.Oauth2Classlink,
  SsoTypeEnum.Oauth2Canvas,
  SsoTypeEnum.OauthCanvas,
];

const SelectForm: React.FC = () => {
  const [params, setParams] = useQueryParams();
  const { watch, getValues } = useFormContext<FormValues>();
  const [district] = watch(['district']);
  const { state: stateValue } = useLocation();
  const [option, setOption] = React.useState<any>([]);

  useGetPublicDistrictsQuery({
    variables: {
      state: stateValue?.stateValue?.toUpperCase() || getValues('state'),
      page: 1,
      itemsPerPage: 2000,
    },
    onCompleted: (data) => {
      const districtOptions =
        data?.newDistricts?.collection?.filter(Boolean).map((item) => ({
          value: item.id,
          label: item.globalName,
        })) || [];

      setOption(
        districtOptions?.find(
          (value) => value?.value === stateValue?.districtId
        )
      );
    },
  });

  const { loading } = useGetPublicDistrictQuery({
    variables: {
      id: district || '',
    },
    onCompleted: (data) => {
      const sso = data.publicDistrict.ssoIntegrations?.[0];

      const params = new URLSearchParams(document.location.search);
      const redirect = params.get('redirect');

      if (sso && autoSso.includes(sso) && redirect !== 'false') {
        window.location.href = `${window.location.origin}/api/login/papi/sso/redirect?district=${district}&sso=${sso}`;
      }
    },
    skip: !district,
  });

  return (
    <VStack spacing={4}>
      <Text
        as="h2"
        fontSize="lg"
        fontWeight="bold"
        alignSelf="flex-start"
        mb={6}
      >
        What district are you in ?
      </Text>
      <SelectState />
      <SelectDistrict option={option} />
      <Flex justifyContent="flex-end">
        <Button
          isDisabled={!district || loading}
          onClick={() => {
            setParams({
              ...params,
              state: getValues('state'),
              district: getValues('district'),
            });
          }}
          variant="solid"
          colorScheme="blue"
        >
          Proceed
        </Button>
      </Flex>
    </VStack>
  );
};

export default SelectForm;
